import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
  },
  // {
  //   path: "/home",
  //   name: "Index",
  //   component: Index,
  // },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/about/Index.vue"),
  },
  {
    path: "/about/culture",
    name: "Culture",
    component: () => import("../views/about/Culture.vue"),
  },
  {
    path: "/about/course",
    name: "Course",
    component: () => import("../views/about/Course.vue"),
  },
  {
    path: "/about/organization",
    name: "Organization",
    component: () => import("../views/about/Organization.vue"),
  },
  {
    path: "/about/honor",
    name: "Honor",
    component: () => import("../views/about/Honor.vue"),
  },
  {
    path: "/project",
    name: "ProjectShow",
    component: () => import("../views/ProjectShow/ProjectShow.vue"),
  },
{
  path: "/projectShow/pro1",
  name: "ProjectPro1",
  component: () => import("../views/ProjectShow/ProjectShow.vue"),
},
{
  path: "/projectShow/pro2",
  name: "ProjectPro2",
  component: () => import("../views/ProjectShow/ProjectShow.vue"),
},
{
  path: "/projectShow/pro3",
  name: "ProjectPro3",
  component: () => import("../views/ProjectShow/ProjectShow.vue"),
},
{
  path: "/projectShow/pro4",
  name: "ProjectPro4",
  component: () => import("../views/ProjectShow/ProjectShow.vue"),
},
{
  path: "/projectShow/pro5",
  name: "ProjectPro5",
  component: () => import("../views/ProjectShow/ProjectShow.vue"),
},
  {
    path: "/news",
    name: "News",
    component: () => import("../views/news/Index.vue"),
  },
  {
    path: "/news/detail/:id",
    name: "NewsDetail",
    component: () => import("../views/news/NewsDetail.vue"),
  },
  {
    path: "/news/industry",
    name: "Industry",
    component: () => import("../views/news/Industry.vue"),
  },
  {
    path: "/news/report",
    name: "Report",
    component: () => import("../views/news/Report.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../views/contact/Index.vue"),
  },
  {
    path: "/contact/relation",
    name: "Relation",
    component: () => import("../views/contact/Relation.vue"),
  },
  {
    path: "/contact/join_us",
    name: "JoinUs",
    component: () => import("../views/contact/JoinUs.vue"),
  },
  {
    path: "/product/lvp",
    name: "Lvp",
    component: () => import("../views/Product/lvp.vue"),
  },
  {
    path: "/product/opm",
    name: "Opm",
    component: () => import("../views/Product/opm"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: "/",
  routes,
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js